// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1i846","actions":"GroupTable_actions__ypkxR","deleteModalFooter":"GroupTable_deleteModalFooter__2Y9-I"};